/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBookingGroupsVisitGroupIdCancelMutationResponse, PostApiBookingGroupsVisitGroupIdCancelPathParams, PostApiBookingGroupsVisitGroupIdCancelQueryParams, PostApiBookingGroupsVisitGroupIdCancel403, PostApiBookingGroupsVisitGroupIdCancel404, PostApiBookingGroupsVisitGroupIdCancel409, PostApiBookingGroupsVisitGroupIdCancel500 } from "../entities/PostApiBookingGroupsVisitGroupIdCancel";

function getPostApiBookingGroupsVisitGroupIdCancelUrl(visit_group_id: PostApiBookingGroupsVisitGroupIdCancelPathParams["visit_group_id"]) {
  const res = { method: 'POST', url: `/api/booking-groups/${visit_group_id}/cancel` as const }
  return res
}

/**
 * @description Отменяет платёж и освобождает зарезервированный слот
 * @summary Отменить неоплаченную веб-бронь
 * {@link /api/booking-groups/:visit_group_id/cancel}
 */
export async function postApiBookingGroupsVisitGroupIdCancel(visit_group_id: PostApiBookingGroupsVisitGroupIdCancelPathParams["visit_group_id"], params: PostApiBookingGroupsVisitGroupIdCancelQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PostApiBookingGroupsVisitGroupIdCancelMutationResponse, ResponseErrorConfig<PostApiBookingGroupsVisitGroupIdCancel403 | PostApiBookingGroupsVisitGroupIdCancel404 | PostApiBookingGroupsVisitGroupIdCancel409 | PostApiBookingGroupsVisitGroupIdCancel500>, unknown>({ method : "POST", url : getPostApiBookingGroupsVisitGroupIdCancelUrl(visit_group_id).url.toString(), params, ... requestConfig })
  return res.data
}